import { get } from '@/base/http-base.js'
//获取登录信息
export function getUserInfo(params) {
  return get('/api/account-api/v1/accountCenter/user', params, {
    isLogin: false
  })
}
